// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"D8-z"};